import React, { FC } from 'react';
import { Grid } from 'enova-frontend-components';

import SoknadBase from '../../components/registering/steps/base/soknadBase';

const NewSoknadRegistration: FC = () => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={8}>
        <SoknadBase />
      </Grid>
    </Grid>
  );
};

export default NewSoknadRegistration;
